import { render } from "./CardCopy.vue?vue&type=template&id=23c1ed3a"
import script from "./CardCopy.vue?vue&type=script&lang=js"
export * from "./CardCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__